<div class="datatable-responsive">
  <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100 nowrap">
    <thead>
      <tr>
        <ng-container *ngFor="let itemTitle of itemsTitles; index as i">
          <th *ngIf="itemTitle !== 'Imprimir boleto'">{{ itemTitle }}</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of items; trackBy: trackByItem">
        <ng-container *ngFor="let itemCollumn of getVisibleAttributesCached(item); trackBy: trackByAttr">
          <td [attr.data-order]="getSortKeyCached(itemCollumn)">
            <span class="dt-badge" [ngClass]="getStatusClass(getItemValueCached(itemCollumn))">
              {{ getItemValueCached(itemCollumn) }}
            </span>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>


